import { Link } from 'react-router-dom'
import { useDongs } from '@/shared/lib/codes'

export function AboutPage() {
  // 동 개수를 화면에 적지 않는다 — 대상 지역이 넓어지면 바로 거짓이 된다.
  const dongs = useDongs()
  const dongCount = dongs.data?.length

  return (
    <>
      <section className="rounded-[10px] border border-white-300 bg-white-50 px-10 py-12">
        <h1>우리 동네의 문제, 함께 해결해 봄!</h1>
        <p>
          해봄은 광명에서 <b>시민이 겪는 생활 문제</b>와 <b>그 문제를 풀 수 있는 지역 기업·기관</b>
          을 잇는 플랫폼입니다. 두 쪽이 각자 알아서 만나기를 기다리는 대신, 같은 기준으로 정리해
          무엇이 맞고 무엇이 비어 있는지 눈에 보이게 합니다.
        </p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Link className="cursor-pointer rounded-lg border border-black-600 bg-black-600 px-[22px] py-[11px] font-semibold text-white-50 disabled:cursor-not-allowed disabled:opacity-50" to="/problems/new">
            문제 등록하기
          </Link>
          <Link className="cursor-pointer rounded-lg border border-black-600 bg-black-600 px-[22px] py-[11px] font-semibold text-white-50 disabled:cursor-not-allowed disabled:opacity-50 border-white-400 bg-white-50 text-black-800" to="/map">
            해봄지도 보기
          </Link>
        </div>
      </section>

      <h2 className="mt-10 mb-3.5 text-body-md font-bold">두 가지로 이뤄져 있습니다</h2>
      <div className="mt-8 grid grid-cols-3 gap-3">
        <div className="rounded-[10px] bg-white-200 p-[18px]">
          <b>카드매칭</b>
          시민이 낸 <b>시민문제카드</b>와 기업이 낸 <b>기업해결카드</b>를 같은 8개 축으로 적어
          둡니다. 두 카드를 나란히 놓으면 도움방식·분야·대상·지역이 어디까지 겹치는지 그대로
          드러납니다. 겹치는 정도는 <b>적합도 점수</b>로 적습니다.
        </div>
        <div className="rounded-[10px] bg-white-200 p-[18px]">
          <b>해봄지도</b>
          같은 자료를 동 단위 지도에 얹습니다. 어디에 문제가 몰려 있는지(수요), 어디에 풀 수 있는
          곳이 있는지(해결역량), 문제는 있는데 받을 곳이 없는 자리는 어디인지(미충족)를 봅니다.
        </div>
      </div>

      <h2 className="mt-10 mb-3.5 text-body-md font-bold">참여하는 방법</h2>
      <div className="mt-8 grid grid-cols-3 gap-3">
        <div className="rounded-[10px] bg-white-200 p-[18px]">
          <b>시민 — 문제를 등록합니다</b>
          회원가입이 없습니다. 겪고 있는 불편을 한 문장으로 적고 동네와 대상만 고르면 됩니다.
          등록한 글을 나중에 고칠 수 있도록 비밀번호를 함께 정합니다.
        </div>
        <div className="rounded-[10px] bg-white-200 p-[18px]">
          <b>기업·기관 — 해결카드를 등록합니다</b>
          풀 수 있는 분야·도움방식·서비스 지역을 시민과 <b>같은 기준</b>으로 적습니다. 한 곳이
          여러 장을 낼 수 있고 <b>최대 3개</b>까지입니다. 접수는 운영기관이 받고 있습니다 —
          아래 문의처로 연락 주세요.
        </div>
      </div>

      <h2 className="mt-10 mb-3.5 text-body-md font-bold">등록한 뒤에는</h2>
      <div className="rounded-lg bg-white-200 px-4 py-3.5 text-label text-black-500">
        <ul>
          <li>
            올린 글은 <b>바로 공개되지 않습니다.</b> 운영기관이 내용을 확인한 뒤 게시하며 보통
            하루(약 24시간) 안에 처리됩니다.
          </li>
          <li>
            <b>연락은 운영기관이 드립니다.</b> 시민과 기업이 이 사이트에서 서로의 연락처를 보거나
            직접 주고받지 않습니다.
          </li>
          <li>
            연락처는 <b>운영자만</b> 볼 수 있고, 지도와 목록에는 <b>동 단위</b>로만 표시합니다.
            자세한 내용은 <Link to="/privacy">개인정보 처리방침</Link>에 적어 두었습니다.
          </li>
        </ul>
      </div>

      <h2 className="mt-10 mb-3.5 text-body-md font-bold">어디를 대상으로 하나요</h2>
      <p className="m-0 mb-7 text-body-sm text-black-100">
        <b>경기도 광명시</b>에서 시범 운영합니다.
        {dongCount !== undefined && <> 광명시 행정동 {dongCount}곳 전체가 대상입니다.</>} 문제를
        등록할 때 고르는 동네와 기업이 적는 서비스 지역이 같은 목록을 씁니다.
      </p>

      <h2 className="mt-10 mb-3.5 text-body-md font-bold">운영</h2>
      <table className="w-full text-body-sm max-[600px]:text-label">
        <tbody>
          <tr>
            <th>운영 주체</th>
            <td>주식회사 이티랩</td>
          </tr>
          <tr>
            <th>문의처</th>
            <td>
              <a href="mailto:etlab.official@gmail.com">etlab.official@gmail.com</a>
            </td>
          </tr>
          <tr>
            <th>현재 상태</th>
            <td>시범 운영 중입니다. 화면과 기능이 계속 바뀝니다.</td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
